
import { defineComponent, onMounted, computed, ref, onBeforeUpdate } from 'vue'
import { useStore } from '@/store/index'
import LayoutsAuth from '@/layouts/Auth.vue'
import VideoListTagCheckbox from '@/components/VideoListTagCheckbox.vue'
import { toArray } from '@/utils/array'
import { dayjs } from '@/plugins/dayjs'
import VideoListDateRangePicker from '@/components/VideoListDateRangePicker.vue'
import VideoListSortSwitch from '@/components/VideoListSortSwitch.vue'
import BasePagination from '@/components/BasePagination.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'
import { getStartDateQuery, getEndDateQuery } from '@/types/forms/date-range-picker'
import { getSortQuery } from '@/types/forms/sort-switch'
import { getSearchQuery } from '@/types/forms/search-word'
import { getTagIdsQuery } from '@/types/forms/tag-checkbox'

export default defineComponent({
  components: {
    LayoutsAuth,
    VideoListTagCheckbox,
    VideoListDateRangePicker,
    VideoListSortSwitch,
    BasePagination,
    LayoutsAuthWidth,
    VideoThumbnail
  },
  setup() {
    const startDate = ref()
    const endDate = ref()
    const sort = ref(true)
    const search = ref()
    const store = useStore()
    const videos = computed(() => {
      return store.getters['video/sortVideosByQuery'](
        store.getters['video/filterVideosByDate'](
          (search.value) ? store.getters['video/filterVideosBySearchWord'](search.value) : store.getters['video/filterVideosByTagIds'](getTagIdsQuery())
        )
      )
    })
    const pageSize = ref(16)
    const pagedList = ref([])

    const initialize = () => {
      startDate.value = getStartDateQuery()
      endDate.value = getEndDateQuery()
      sort.value = getSortQuery()
      search.value = getSearchQuery()
    }

    onMounted(() => {
      initialize()
      store.dispatch('video/fetchVideos')
    })

    onBeforeUpdate(() => {
      initialize()
    })

    return {
      store,
      videos,
      toArray,
      startDate,
      endDate,
      pageSize,
      pagedList,
      dayjs,
      sort
    }
  },
})
